import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useState } from "react";
import "./productInfoPanel.css";

const ProductInfoPanel = (props: any) => {
  const [isExpanded, setExpanded] = useState(false);

  const alwaysExpand = props.alwaysExpand ?? false;

  const handleOnClick = () => {
    if (alwaysExpand) return;
    setExpanded(!isExpanded);
  };

  return (
    <div className="panel panel-default">
      <div className="panel-heading" onClick={handleOnClick}>
        {alwaysExpand && (
          <span className="panel-title panel-title-colored">{props.title}</span>
        )}
        {!alwaysExpand && (
          <>
            <div className="panel-title-container col-lg-4 col-md-8 col-11">
              <a className="panel-title">{props.title}</a>
              {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
            </div>
            <div className="col-lg-8 col-md-4 col-1">&nbsp;</div>
          </>
        )}
      </div>
      <div
        className={
          alwaysExpand || isExpanded ? "panel-body" : "panel-body-collapsed"
        }
        dangerouslySetInnerHTML={{ __html: props.body }}
      ></div>
    </div>
  );
};

export default ProductInfoPanel;
